import { MenuItem, Paper, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Field } from 'formik';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getRlationWith } from '../../../../../redux/features/generalSlice';

export default function GuardianDetailsSection({ touched, errors }) {
  const { relWith, loading } = useSelector((state) => state.general);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getRlationWith());
  }, []);

  return (
    <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" mb={6}>
        Guardian Details
      </Typography>
      <Box display={'flex'} gap={2} flexDirection={'column'} maxWidth={900}>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="guardian"
            label="Guardian"
            name="guardian"
            error={touched.guardian && Boolean(errors.guardian)}
            helperText={touched.guardian && errors.guardian}
          />
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="relationWithStudent"
            label="Relation With Student"
            name="relationWithStudent"
            error={touched.relationWithStudent && Boolean(errors.relationWithStudent)}
            helperText={touched.relationWithStudent && errors.relationWithStudent}
            disabled={!Boolean(relWith?.length)}
            select
          >
            {relWith?.map((e, i) => (
              <MenuItem value={Number(e.relationship_id)} key={i}>
                {e.relationship_name}
              </MenuItem>
            ))}
          </Field>
        </Box>
      </Box>
    </Paper>
  );
}
